<template>
    <v-select
        @input="onChangeHandler"
        :options="tagList"
        :value="value"
        :reduce="tag => (isTaggable ? tag : tag.code)"
        :taggable="isTaggable"
        :calculate-position="withPopper"
        :placeholder="placeholder"
        ref="tag-select"
        append-to-body
        multiple
    >
        <template slot="option" slot-scope="option">
            <div class="d-flex py-1" style="ovarflow: auto">
                <p class="mb-0">{{ option.label }}</p>
                <p
                    class="mb-0 ml-2 text-capitalize px-2 rounded-pill shadow"
                    :class="{
                        'bg-info': option.type === 'category',
                        'bg-danger': option.type === 'quiz',
                        'bg-warning': option.type === 'question'
                    }"
                >
                    {{ option.type }}
                </p>
            </div>
        </template>
    </v-select>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
    name: 'tag-select',

    props: {
        tagList: {
            type: Array
        },

        value: {
            type: Array,
            default: null
        },

        returnObject: {
            type: Boolean,
            default: false
        },

        isTaggable: {
            type: Boolean,
            default: false
        },

        placeholder: {
            type: String,
            default: 'Filter by tag'
        }
    },

    data() {
        return {
            placement: 'bottom'
        }
    },

    watch: {
        value(val) {
            if (typeof val !== 'undefined') {
                this.checkTagType(val)
            }
        }
    },

    created() {
        this.checkTagType(this.value)
    },

    methods: {
        onChangeHandler(value) {
            this.$emit('input', value)
        },

        checkTagType(value) {
            const categoryIndex = []

            if (value) {
                value.forEach((item, index) => {
                    this.tagList.forEach(tag => {
                        let code = this.returnObject ? item.code : item

                        if (tag.code === code && tag.type === 'category') {
                            categoryIndex.push(index)
                        }
                    })
                })

                setTimeout(() => {
                    this.setColorForTag(categoryIndex)
                }, 100)
            }
        },

        setColorForTag(categoryIndex) {
            if (this.$refs['tag-select']) {
                let tagSelected = this.$refs['tag-select'].$el.getElementsByClassName('vs__selected')

                categoryIndex.forEach(item => {
                    tagSelected.forEach((elem, index) => {
                        if (item === index) {
                            tagSelected[index].style.backgroundColor = '#17a2b8'
                            tagSelected[index].style.borderColor = '#17a2b8'
                            tagSelected[index].style.boxShadow = '0px 0px 10px rgba(23, 162, 184, 0.3)'
                        }
                    })
                })
            }
        },

        withPopper(dropdownList, component, { width }) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1]
                        }
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top')
                        }
                    }
                ]
            })
            return () => popper.destroy()
        }
    }
}
</script>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

@media screen and (max-width: 500px) {
    .modal .vs__dropdown-toggle .vs__selected-options {
        max-height: 4rem;
        overflow: auto;
    }
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
